module.exports = { id: "check", url: "/build/app/img/symbols.svg#check", viewBox: "", toString: function() { return this.url; } };